import React from 'react';

import { regFlowCompleteKey } from '../registration/registration-utils';
import { storeValue } from '../storage/storage-utils';
import RegistrationComplete from '../registration/RegistrationComplete';


/* location props via Reach Router */
const SignUpCompleteController = () => {
  
  // set storage key for use on marketing site
  storeValue(regFlowCompleteKey, true); 

  return (
    <RegistrationComplete />
  )
}

export default SignUpCompleteController;